// src/components/teaching/StudentsList.jsx
import React from 'react';

const StudentsList = () => {
    const students = {
        current: [

{
                name: "Vitor Jose Da Silva Carvalho",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, Robotics",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Desenvolvimento e validação de uma arquitetura computacional para manipulação de objetos por robôs humanoides"
            },

{
                name: "Ricardo Filipe Nabais Figueira De Almeida",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, Knowledge representation",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Ontology-Based Explainable AI for Recommendation Systems"
            },

            {
                name: "Nuno Ferreira Aguiar",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "IoT, Computer Vision",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Sistema de Monitorização e Indicação Visual de Ocupação de Carruagens."
            },
 {
                name: "Maria Ruth Da Silva Resende",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Data Quality, Data Models, No-code",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Uma Abordagem Visual à Validação Automática de Dados."
            },

             {
                name: "Tainá Santos Medeiros",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, LLM, Cyber Forensics",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Forensic Reconstruction of Autonomous LLM Agents"
            },


             {
                name: "Gonçalo Pinto",
                level: "MSc in Informatics and Multimedia Engineering",
                topic: "AI, Knowledge Graphs",
                year: "2026-present",
                institution: "UPL/ISEL",
                thesis: "Knowledge Graph-Based Recommendation System for Drug Repositioning"
            },


            {
                name: "Goncalo Dos Reis Garranha",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, Healthcare",
                year: "2025-present",
                institution: "IPL/ISEL",
                thesis: "Knowledge Graph-Based Recommender Systems for Biomedical Drug Discovery"
            },
             {
                name: "Joao Carlos Monteiro Rocha",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Data Quality, Data Models",
                year: "2025-present",
                institution: "IPL/ISEL",
                thesis: "Integrated System for Data Quality"
            },
            {
                name: "Pedro Miguel Calhau Mateus",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "LLM, AI, Cybersecurity",
                year: "2025-present",
                institution: "IPL/ISEL",
                thesis: "Attack Resilience: Architectural Approaches to Protecting LLMs in Open Environments"
            },
            {
                name: "Luis Campanela",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Data lake, OLAP",
                year: "2024-present",
                institution: "IPL/ISEL",
                thesis: "Implementation of Data Lake for Maritime Container Transport"
            },
            
            {
                name: "Fábio Rainho",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Machine Learning, Healthcare",
                year: "2024-present",
                institution: "IPL/ISEL",
                thesis: "Sistema de Recomendação baseado na aprendizagem automática para investigação em doenças respiratórias (BreatheEase Scholar)"
            }
            // Add more current students
        ],
        past: [
            {
                name: "Rafael Carvalho",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Machine Learning, Healthcare",
                year: "2024-2025",
                institution: "IPL/ISEL",
                thesis: "A Topic Modelling-Based Recommender System for Drugs Using User Experience Reviews"
            },
            {
                name: "João Filipe Miguel da Costa e Silva",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Cyber-physical System, HCI",
                year: "2024-2025",
                institution: "IPL/ISEL",
                thesis: "A Unified Communication Architecture for Smart Locker Networks and Mobile Access"
            },
            {
                name: "Ana Sofia Simões Pinto",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Recommender System, ML, NLP",
                year: "2023-2024",
                institution: "IPL/ISEL",
                thesis: "Drug Recommendation System Based on Symptoms and User Sentiment Analysis [DRecSys-SUSA]",
            },
            {
                name: "Diogo Amorim",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Big Data, Python, Feature Selection",
                year: "2023-2024",
                institution: "IPL/ISEL",
                thesis: "Biblioteca Python para seleção de características em grandes dados",
            },
            {
                name: "Samuel Sampaio Costa",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, KANs, Human-Activity Recognition",
                year: "2023-2024",
                institution: "IPL/ISEL",
                thesis: "Real-time Human Activity Recognition with KANs",
            },
            {
                name: "Marta Ferreira",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Visualization, Dashboard, ML",
                year: "2023-2024",
                institution: "IPL/ISEL",
                thesis: "Study and Modeling of CTT Locker Operation",
            },
            {
                name: "Alexandre Santos Rocha",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Web API, Human Computer Interaction",
                year: "2022-2024",
                institution: "IPL/ISEL",
                thesis: "Editor para testes semi-automáticos de Web API",
            },
            {
                name: "Nuno Bragança",
                level: "MSc in Electronics and Telecommunications Engineering",
                topic: "AI, Optimization, 5G",
                year: "2022-2024",
                institution: "IPL/ISEL",
                thesis: "User Equipment Throughput Enhancement using Base Station Cooperation with Particle Swarm Optimisation in 5G",
            },
            {
                name: "Renato Marcelo",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Recommender System, Patient Leaftlet Information, ML",
                year: "2022-2023",
                institution: "IPL/ISEL",
                thesis: "Med2Care - Recomendação de novas terapêuticas",
            },
            {
                name: "Ricardo Severino",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Security, Intelligent Transportation Systems",
                year: "2022-2023",
                institution: "IPL/ISEL",
                thesis: "Segurança num contexto de redes hibridas em ITS",
            },
            {
                name: "Pedro Santos",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Recommender System, AI, ML",
                year: "2021-2022",
                institution: "IPL/ISEL",
                thesis: "Aprendizagem automática aplicada à gestão de ativos",
            },
            {
                name: "Nuno Gomes",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, ML, Mental Health, App ",
                year: "2021-2022",
                institution: "IPL/ISEL",
                thesis: "Anxolotl - an anxiety companion app",
            },
            {
                name: "Duarte Filipe de Melo dos Santos Felicio",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Web Development, Testing",
                year: "2021-2022",
                institution: "IPL/ISEL",
                thesis: "RapiTest - Aplicação Web para testar WEB API",
            },
            {
                name: "Othmane El Arbaoui",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Smart Cities, DCAT-AP, Knowledge management",
                year: "2021-2023",
                institution: "IPL/ISEL",
                thesis: "Modelo integrado de dados abertos para Smart cities",
            },
            {
                name: "Mafalda Sofia Compadrinho Gonçalves",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Safety, Intelligent Transportation Systems, Human Computer Interaction",
                year: "2021-2023",
                institution: "IPL/ISEL",
                thesis: "A safety perspective for soft mobility in the ITS ecosystem",
            },
            {
                name: "Lucas Manuel Vieira da Fonseca",
                level: "MSc in Computer Science",
                topic: "Smart Cities, Visual Analytics",
                year: "2021-2023",
                institution: "NOVA FCT",
                thesis: "Mobilidade urbana medida a partir de dados agregados de telemóveis",
            },
            {
                name: "João Vaz",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, ML, Visual Analytics, App ",
                year: "2020-2021",
                institution: "IPL/ISEL",
                thesis: "Indicador de tráfego: descoberta de padrões na cidade de Lisboa",
            },
            {
                name: "Henrique Gomes",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, ML, R, Big Data",
                year: "2020-2021",
                institution: "IPL/ISEL",
                thesis: "Desenvolvimento de um package em R para ensemble feature ranking",
            },
             {
                name: "Ivo Pedroso",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Distributed Systems",
                year: "2020-2022",
                institution: "IPL/ISEL",
                thesis: "Plataforma descentralizada de monitorização de poluição",
            },
            {
                name: "Rúben Taborda",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, ML, R, Big Data, Smart Cities",
                year: "2019-2021",
                institution: "IPL/ISEL",
                thesis: "Estudo Preditivo da Evolução CO2 na cidade de Lisboa",
            },
             {
                name: "Ana Sofia Lopes Afonso",
                level: "MSc in Computer Science",
                topic: "Smart Cities, Visual Analytics",
                year: "2019-2021",
                institution: "NOVA FCT",
                thesis: "Predição da Procura de Bicicletas para Otimizar o Rebalanceamento das Bicicletas Partilhadas em Lisboa",
            },
             {
                name: "Leonardo Melo",
                level: "MSc in Computer Science and Multimedia",
                topic: "Smart Cities, Visualization",
                year: "2019-2021",
                institution: "IPL/ISEL",
                thesis: "Quality of life index for smart cities",
            },
            {
                name: "Rui Reis",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "AI, ML, R",
                year: "2018-2019",
                institution: "IPL/ISEL",
                thesis: "Modelo de recuperação da vegetação após ocorrência de incêndios florestais baseado em imagens de satélite",
            },
                        {
                name: "João Ribeiro",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Distributed Systems",
                year: "2018-2020",
                institution: "IPL/ISEL",
                thesis: "Profiling KPIs in highly scalable networks",
            },
                        {
                name: "Nuno Ribeiro",
                level: "MSc in Computer Science",
                topic: "Data Analysis",
                year: "2017-2019",
                institution: "NOVA FCT",
                thesis: "Anotação e Extração Semi-Automática de dados multidimensionais",
            },
            {
                name: "Daniel Bicho",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Machine Learning, Deep Neural Networks",
                year: "2017-2019",
                institution: "IPL/ISEL",
                thesis: "Identificação Automática de Conteúdos NSFW",
            },
            {
                name: "João Junceira",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "R, Big Data, ML",
                year: "2016-2017",
                institution: "IPL/ISEL",
                thesis: "Análise de soluções para Big Data Mining",
            },
             {
                name: "Vítor Paulino",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Distributed Systems, Complex Event Processing",
                year: "2016-2017",
                institution: "IPL/ISEL",
                thesis: "Utilização de eventos aplicacionais para análise de negócio em tempo real",
            },
            {
                name: "Maria Emerene Henriques Simão",
                level: "MSc in Engenharia de Telecomunicações e Informática",
                topic: "Data warehouse, Business Inteligence, OLAP",
                year: "2014-2016",
                institution: "ISCTE",
                thesis: "Sistema de apoio à decisão sobre o excesso do prazo de prisão preventiva",
            },
            {
                name: "Vasile Grigoras",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "R, Big Data, ML",
                year: "2014-2015",
                institution: "IPL/ISEL",
                thesis: "ALSMon - Sistema para monitorizar ALS",
            },
             {
                name: "David Santos",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "ML, Spatio-temporal Analysis, Segmentation",
                year: "2012-2014",
                institution: "IPL/ISEL",
                thesis: "Segmentação Automática de Memórias Pessoais",
            },
            {
                name: "Vírginia Ramalho",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "R, Data mining, ML",
                year: "2012-2013",
                institution: "IPL/ISEL",
                thesis: "Modelo de data mining para detecção de embolias pulmonares em exames de rastreio",
            },
            {
                name: "Vítor Santos",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "R, Data mining, ML",
                year: "2012-2013",
                institution: "IPL/ISEL",
                thesis: "Modelo de data mining para detecção de de tumores em exames de rastreio",
            },
            {
                name: "Alexandre Rodrigues",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Web Development",
                year: "2010-2012",
                institution: "IPL/ISEL",
                thesis: "Find-a-Meal: Sistema de Sugestão de Restaurantes",
            },
            {
                name: "João Zorro",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Machine Learning",
                year: "2009-2010",
                institution: "IPL/ISEL",
                thesis: "Técnicas de Mineração de Dados aplicadas ao Mercado de Capitais",
            },
            {
                name: "Inês Martins",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Business Inteligence, Data Warehouse",
                year: "2009-2010",
                institution: "IPL/ISEL",
                thesis: "Framework genérica de Business Inteligence para suporte financeiro",
            },
             {
                name: "Jorge Santos",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "Distributed Systems",
                year: "2008-2010",
                institution: "IPL/ISEL",
                thesis: "Sistema interactivo para suporte à aprendizagem",
            },
            {
                name: "David Duque",
                level: "MSc in Computer Science and Computer Engineering",
                topic: "OLAP, Data Warehouse",
                year: "2008-2010",
                institution: "IPL/ISEL",
                thesis: "Servidor de integração OLAP",
            }
        ]
    };

    return (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">Students</h2>

            {/* Current Students - Keeping detailed format */}
            <div className="mb-6">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                    Current Students
                </h3>
                <div className="space-y-4">
                    {students.current.map((student, index) => (
                        <div key={index} className="border-l-4 border-blue-500 pl-4">
                            <p className="font-semibold text-gray-900 dark:text-white">
                                {student.name}
                            </p>
                            <p className="text-gray-600 dark:text-gray-300">
                                {student.level} Student • {student.institution}
                            </p>
                            <p className="text-gray-500 dark:text-gray-400">
                                {student.thesis} ({student.year})
                            </p>
                            <p className="text-gray-500 dark:text-white">
                                [{student.topic}]
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {/* Past Students - Compact format */}
            <div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">
                    Past Students
                </h3>
                <div className="divide-y divide-gray-200 dark:divide-gray-700">
                    {students.past.map((student, index) => (
                        <div key={index} className="py-2">
                            <div className="flex flex-wrap items-baseline gap-x-2">
                                <span className="font-medium text-gray-900 dark:text-white">
                                    {student.name}
                                </span>
                                <span className="text-gray-600 dark:text-gray-300">
                                    ({student.level}, {student.institution}, {student.year})
                                </span>
                                <span className="text-gray-500 dark:text-gray-400 italic">
                                    {student.title}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default StudentsList;